import { ReactElement } from "react";
import { IPurchasesListingProps } from "./types";
import { Stack } from "@mantine/core";
import { getPurchaseCard } from "./utils";

export default function PurchasesListing({
  purchases,
  account,
  paymentMethod,
  defaultSection,
}: IPurchasesListingProps): ReactElement {
  return (
    <Stack data-testid="PurchasesListing" spacing="lg">
      {purchases.map((purchase) => {
        const PurchaseCardComponent = getPurchaseCard(purchase);

        return (
          <PurchaseCardComponent
            key={purchase.id}
            purchase={purchase}
            account={account}
            paymentMethod={paymentMethod}
            defaultSection={defaultSection}
          />
        );
      })}
    </Stack>
  );
}
